import styled, { css } from 'styled-components';
import { mobile_xl } from '../../../global/mediaQueryMixin';
import { Typography } from '../../../global/theme';

export const Menu = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: var(--space-8);
  ${mobile_xl(css`
    gap: var(--space-4);
    &.last-child {
      border-bottom: unset;
    }
  `)};
`;

export const Title = styled.div`
  padding-inline: var(--space-18);
  p {
    ${Typography.body_md_medium}
    color: var(--text-secondary);
    margin: var(--space-0);
  }
  ${mobile_xl(css`
    font-weight: 600;
    padding-inline: var(--space-20);
  `)};
`;

export const MenuItems = styled.div`
  padding-inline: var(--space-12);
  width: -webkit-fill-available;
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
  ${mobile_xl(css`
    gap: var(--space-4);
  `)};
`;
